var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selected-colors",class:{
    reverse: _vm.isReversedLayout,
  }},[_vm._t("item-back"),_vm._t("item-front")],2)}
var staticRenderFns = []

export { render, staticRenderFns }